<template>
  <div>
    <segment-edit :segment="segment"/>
    <segment-job-board :segment="segment" v-loading="loading" :job-boards="mappedJobBoards"/>
  </div>
</template>
<script>
  import { Tabs, TabPane } from 'src/components'
  import SegmentEdit from './SegmentEdit'
  import SegmentJobBoard from './SegmentJobBoard'
  import SegmentGroupService from 'src/services/SegmentGroupService'
  import JobBoardService from 'src/services/JobBoardService'

  export default {
    name: 'segments-overview-settings',
    components: {
      Tabs,
      TabPane,
      SegmentEdit,
      SegmentJobBoard
    },
    computed: {},
    data () {
      return {
        segment: {},
        jobBoards: [],
        mappedJobBoards: [],
        loading: false
      }
    },
    methods: {
      async getSegmentInformation(segmentId) {
        try {
          this.loading = true
          const res = await SegmentGroupService.getById(segmentId, {with: 'job_boards,segments'})
          this.segment = res.data
          const { data } = await JobBoardService.get();
          this.jobBoards = data;
          this.mappedJobBoards = this.jobBoards.map(j => {
            let status = '';
            let segmentJobBoard = this.segment.job_boards.find(s => s.id === j.id);
            if(segmentJobBoard) {
              status = 'active';
            }
            return {
              ...j,
              status
            }
          })
        } finally {
          this.loading = false
        }
      },
      async languageChange() {
        await this.getSegmentInformation(this.$route.params.id)
      }
    },
    watch: {
      '$store.state.config.textLanguage' () {
        this.languageChange()
      },
    },
    async beforeRouteEnter (to, from, next) {
      try {
        let id = to.params.id
        next(async vm => {
          await vm.getSegmentInformation(id)
        })
      } catch (e) {
        next(vm => vm.error = e)
      }
    },
  }
</script>
<style lang="scss" scoped>
</style>
